import $ from 'jquery';

export default function () {
    console.log('Custom Select Module Loaded');
    // Setup the main custom dropdown
    var dropdown = $('<div />').addClass('custom-select__absolute-dropdown').appendTo('body');

    $('body')
        .on('mousedown', '.custom-select:not(.custom-select--disabled) select', function (e) {
            var container = $(this).parents('.custom-select'),
                customSelect = $(this),
                customDropdown = $('.custom-select__dropdown', container);
            if (customDropdown.length || container.data('url')) {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.blur(); /* prevent the dropdown for crap browsers */
                window.focus();
                dropdown.hide();
            }

            if (customDropdown.length) {
                customDropdown.addClass('d-block');
                $('.custom-select').not(container).removeClass('custom-select--visible');
                container.toggleClass('custom-select--visible');
            } else if (container.data('url')) {
                var offset = customSelect.offset();
                // Set some references for later when the user clicks a data-val
                dropdown
                    .data('container', container)
                    .data('select', customSelect)
                    .empty()
                    .css({
                        top: offset.top + $(this).outerHeight(),
                        left: offset.left,
                        minWidth: $(this).width()
                    });

                $.ajax({
                    cache: false,
                    url: container.data('url'),
                    success: function (data) {
                        dropdown.html(data).show();
                    },
                    error: function () {
                        dropdown.text('There has been an error while retrieving sizes. Please refresh and try again.');
                    }
                });
            }
        })
        .on('click', '.custom-select select', function (e) {
            e.preventDefault();

            var container = $(this).parents('.custom-select'),
                customSelect = $(this),
                customDropdown = $('.custom-select__dropdown', container);

            if (customDropdown.length || container.data('url')) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        })
        .on('change', '.custom-select select', function (e) {
            // Set the data selectedval so we can use it elsewhere
            e.preventDefault();
            $(this).data('selectedval', $(this).val());
            var parentContainer = $(this).parents('.custom-select');
            let hiddenInput = $('[type="hidden"]', parentContainer);
            parentContainer.find('.custom-select__value').text($(this).find('option:selected').text());
            hiddenInput.val($(this).val()).trigger('change');

            fireJSChange(hiddenInput[0]);
        });

    // Click anywhere else to close the dropdowns
    $('body').on('click', function () {
        $('.custom-select__absolute-dropdown').hide();
        $('.custom-select').removeClass('custom-select--visible');
    });

    $('.custom-select--country').on('click', function () {
        $(this)
            .find('.custom-select__country')
            .each(function (e) {
                $(this).attr('style', $(this).data('style'));
            });
    });

    $(document).on('click', '.custom-select__absolute-dropdown [data-value], .custom-select [data-value]', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var container = $(this).parents('.custom-select'),
            customSelect = $('select', container);

        let thisContainer = container.length ? container : dropdown.data('container');
        let thisSelect = customSelect.length ? customSelect : dropdown.data('select');
        let hiddenInput = $('[type="hidden"]', thisContainer);

        if (container.hasClass('custom-select--relationship')) {
            if ($(this).data('value') === 1) {
                $('.form-row--anniversary').addClass('hidden');
            } else {
                $('.form-row--anniversary').removeClass('hidden');
            }
        }

        hiddenInput.val($(this).data('value')).trigger('change');
        fireJSChange(hiddenInput[0]);

        $('option', thisSelect).text($(this).text());
        $('.custom-select__value', thisContainer).html($(this).html());
    });
}

function fireJSChange(elm: HTMLElement) {
    if (!elm) return;
    var event = new Event('change');
    elm.dispatchEvent(event);
}
